class DomCleanupManager {
    private registrations = new Map<number, DomCleanupRegistration>()
    private nextId = 1

    public register(config: DomCleanupConfig): DomCleanupHandle {
        const id = this.nextId++

        const normalizedConfig: DomCleanupConfig = {
            ...config,
            parentClassesToRemove: config.parentClassesToRemove ?? [
                "toolbox-field--rich",
                "toolbox-field__input--preWrapWhitespace",
                "ck-content",
            ],
            parentIdsToRemove: config.parentIdsToRemove ?? ["nostyle"],
        }

        const registration: DomCleanupRegistration = {
            id,
            config: normalizedConfig,
        }

        this.registrations.set(id, registration)
        this.runCleanupForRegistration(registration)

        return {
            unregister: (): void => {
                this.unregister(id)
            },
            cleanup: (): void => {
                this.cleanup(id)
            },
        }
    }

    public unregister(id: number): void {
        this.registrations.delete(id)
    }

    public cleanup(id?: number): void {
        if (typeof id === "number") {
            const registration = this.registrations.get(id)

            if (!registration) {
                return
            }

            this.runCleanupForRegistration(registration)
            return
        }

        for (const registration of this.registrations.values()) {
            this.runCleanupForRegistration(registration)
        }
    }

    public destroy(): void {
        this.registrations.clear()
    }

    private runCleanupForRegistration(
        registration: DomCleanupRegistration,
    ): void {
        const {
            element,
            parentClassesToRemove = [],
            parentIdsToRemove = [],
        } = registration.config

        if (!element.isConnected) {
            this.registrations.delete(registration.id)
            return
        }

        // NEWUI
        // We need to remove the parent rtf's hardcoded classes
        // to ensure we have the correct styling
        parentClassesToRemove.forEach((className: string): void => {
            const parent = element.closest(`.${className}`)

            if (parent) {
                parent.classList.remove(className)
            }
        })

        // OLDUI
        // We need to remove the parent rtf's hardcoded ID
        // otherwise we have overflowing css problems
        parentIdsToRemove.forEach((idToRemove: string): void => {
            const ancestor = element.closest(`#${idToRemove}`)

            if (ancestor) {
                ancestor.id = ""
            }
        })
    }
}

export default new DomCleanupManager()
